import { computed, unref } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { isAiBotPlaygroundInbox } from 'dashboard/helper/inboxPublicLink';

// Real inboxes (the Playground sandbox excluded) whose active agent bot is the given bot. Callers dispatch
// `inboxes/get` + `agentBots/fetchAgentBotInbox` to fill the store.
export const useAttachedInboxes = botId => {
  const store = useStore();
  const inboxes = useMapGetter('inboxes/getInboxes');

  return computed(() =>
    (inboxes.value || []).filter(inbox => {
      if (isAiBotPlaygroundInbox(inbox)) return false;
      const activeId = store.getters['agentBots/getActiveAgentBot'](
        inbox.id
      )?.id;
      return activeId != null && String(activeId) === String(unref(botId));
    })
  );
};
